export const industryContent = {
  dentists: {
    id: "dentists",
    title: "Dentists & Dental Practices",
    heroTitle: "Never Miss an Emergency Patient Again",
    heroSubtitle: "While you're performing a root canal, your AI receptionist is answering the next high-value patient, qualifying their emergency, and booking them into your Dentrix or Open Dental calendar.",
    image: "https://images.unsplash.com/photo-1629909606655-d263320314a5?auto=format&fit=crop&q=80&w=2000",
    stats: [
      { value: "42%", label: "Of new patients call after hours or during lunch.", icon: "Clock", color: "text-blue-400" },
      { value: "$450+", label: "Average lifetime value of a single new patient lead.", icon: "DollarSign", color: "text-emerald-400" },
      { value: "88%", label: "Of patients book with the first practice that answers.", icon: "UserCheck", color: "text-purple-400" }
    ],
    painPoints: [
      "Front desk overwhelmed during morning rushes",
      "High-value emergency calls missed after 5 PM",
      "Patients hanging up on voicemails to call the next clinic"
    ]
  },
  legal: {
    id: "legal",
    title: "Law Firms & Attorneys",
    heroTitle: "The AI Intake Specialist Your Firm Needs",
    heroSubtitle: "In the legal world, speed is everything. AutoReception answers every inquiry instantly, performs basic conflict checks, and schedules consultations while you're in court or discovery.",
    image: "https://images.unsplash.com/photo-1589829545856-d10d557cf95f?auto=format&fit=crop&q=80&w=2000",
    stats: [
      { value: "10 Sec", label: "Response time for every new lead, 24/7/365.", icon: "Zap", color: "text-amber-400" },
      { value: "35%", label: "Increase in billable hours by automating intake.", icon: "TrendingUp", color: "text-blue-400" },
      { value: "$2,500+", label: "Minimum lost revenue for every missed retainer lead.", icon: "Briefcase", color: "text-emerald-400" }
    ],
    painPoints: [
      "Missing high-value PI or Family Law leads after hours",
      "Interrupting deep work for basic qualifying questions",
      "Losing leads to firms with 24/7 live answering services"
    ]
  },
  realestate: {
    id: "realestate",
    title: "Real Estate Agencies",
    heroTitle: "Respond to Every Listing Inquiry in Seconds",
    heroSubtitle: "Zillow and StreetEasy leads don't wait. Our AI answers every call, provides property details from your MLS, and schedules showings directly on your calendar.",
    image: "https://images.unsplash.com/photo-1560518883-ce09059eeffa?auto=format&fit=crop&q=80&w=2000",
    stats: [
      { value: "7x Higher", label: "Conversion rate when responding within 5 minutes.", icon: "TrendingUp", color: "text-emerald-400" },
      { value: "24/7", label: "Availability for international buyers and late-night browsers.", icon: "Globe", color: "text-blue-400" },
      { value: "65%", label: "Of buyers work with the first agent who responds.", icon: "UserPlus", color: "text-orange-400" }
    ],
    painPoints: [
      "Missing hot leads while at a different showing",
      "Inability to handle lead volume during market peaks",
      "Wasted time on unqualified 'just looking' callers"
    ]
  },
  medspa: {
    id: "medspa",
    title: "Med Spas & Beauty Salons",
    heroTitle: "Never Miss a Booking While You're Making Clients Glow",
    heroSubtitle: "While you're focused on a treatment, your AI receptionist is answering the phone, qualifying new clients, and booking appointments directly into your Zenoti, Vagaro, or Boulevard calendar.",
    image: "https://images.unsplash.com/photo-1560750588-73207b1ef5b8?auto=format&fit=crop&q=80&w=2000",
    stats: [
      { value: "38%", label: "Of bookings happen after hours or during treatments.", icon: "Clock", color: "text-pink-400" },
      { value: "$1,200+", label: "Average annual LTV for a recurring aesthetic client.", icon: "DollarSign", color: "text-emerald-400" },
      { value: "92%", label: "Of clients won't leave a voicemail and will call the next spa.", icon: "PhoneMissed", color: "text-red-400" }
    ],
    painPoints: [
      "Front desk staff tied up with check-ins and product sales",
      "Missing high-value filler or laser consultation calls during peak hours",
      "Clients hanging up on hold music to book with a competitor"
    ]
  },
  hvac: {
    id: "hvac",
    title: "HVAC & Home Services",
    heroTitle: "Capture Every Emergency Repair Call, 24/7",
    heroSubtitle: "While you're on a roof or in a crawlspace, your AI receptionist is answering the phone, qualifying the job, and booking the dispatch directly into your ServiceTitan or Housecall Pro calendar.",
    image: "https://images.unsplash.com/photo-1581094288338-2314dddb7ecb?auto=format&fit=crop&q=80&w=2000",
    stats: [
      { value: "58%", label: "Of emergency repair leads call after standard business hours.", icon: "Wind", color: "text-blue-400" },
      { value: "$3,500+", label: "Average revenue from a single missed HVAC system replacement.", icon: "DollarSign", color: "text-emerald-400" },
      { value: "95%", label: "Of customers will call the next contractor if you don't answer.", icon: "PhoneMissed", color: "text-red-400" }
    ],
    painPoints: [
      "Technicians distracted by intake calls while performing service",
      "Missing high-ticket replacement leads during weather extremes",
      "Wasted marketing spend on leads that end up in voicemail"
    ]
  }
};